import styled from "styled-components";
import { Button } from "@viagogo/core/ui";

export const StyledButton = styled(Button)`
  width: max-content;
`;

export const StyledIconWrapper = styled.div`
  height: 20px;
  width: 20px;
  margin-left: ${(props) => props.theme.spacing(2)};
`;
